import React from "react";
import PageShell from "@/components/PageShell";
import PageHeader from "@/components/PageHeader";
import Blog from "@/components/sections/Blog";
import CTASection from "@/components/CTASection";

export default function InsightsPage() {
    return (
        <PageShell>
            <div data-testid="insights-page">
                <PageHeader
                    eyebrow="Insights & News"
                    title="Sharper traders."
                    accent="Shorter learning curves."
                    subtitle="Field-tested perspectives from our outreach desk — covering Vantage products, market structure, and the philosophy behind ethical client development."
                    breadcrumbs={[{ label: "Insights" }]}
                />
                <Blog />
                <CTASection
                    eyebrow="Stay In Touch"
                    title="Want the next briefing in"
                    accent="your inbox?"
                    subtitle="Subscribe in the footer below for weekly insights tailored to traders considering Vantage Markets."
                />
            </div>
        </PageShell>
    );
}
